module.exports = __webpack_public_path__ + "static/media/galerija_2019 (34).ce990cc6.jpg";